import { render } from "./BlockPage.vue?vue&type=template&id=f1326308"
import script from "./BlockPage.vue?vue&type=script&lang=js"
export * from "./BlockPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__